var TypeaheadUtil;
$(document).ready(function () {
    TypeaheadUtil = (function ($, arc) {

        /**
         * Cancels the pending suggestion timer and request of an input, if any.
         * @param {jQuery} $input The input the typeahead is attached to.
         */
        function cancelPending($input) {
            var pending = $input.data('typeaheadPending');
            if (pending) {
                clearTimeout(pending.timer);
                pending.timer = null;
                if (pending.request) {
                    pending.request.abort();
                    pending.request = null;
                }
            }
        }

        /**
         * Initializes a typeahead input for selection(for now it is customized for component selection but could be changed and reused in other cases in future).
         * @param {jQuery} $input The jQuery element representing the input to be enhanced with typeahead functionality.
         * @param {string} resourcePath The server endpoint from which to fetch suggestions based on the user's input.
         * @param {string} tooltipSelector the selector for tooltip.
         * @param {string} indictedComponentsIds the list in string format of indicted components Ids selected on step 2.
         * @param {Function} setValue A callback function to handle the selection of a suggestion.
         * @returns {Object} The initialized typeahead instance attached to the provided input element.
         */
        function initializeTypeahead($input, resourcePath, indictedComponentsIds, tooltipSelector, setValue) {
            // A pending request of the previous widget would call back into it after it is gone.
            cancelPending($input);
            $input.typeahead('destroy');
            // One request for a pause in typing instead of one per keystroke; an outdated request is aborted.
            var pending = { timer: null, request: null };
            $input.data('typeaheadPending', pending);
            var typeahead = $input
                .typeahead(
                    {
                        hint: true,
                        highlight: true,
                        height: 100,
                    },
                    {
                        name: 'source',
                        display: function(suggestion) {
                            return suggestion.title;
                        },
                        source: function(query, sync, async) {
                            cancelPending($input);
                            pending.timer = setTimeout(function () {
                                pending.request = $.ajax($i.contextPath + resourcePath + "?query=" + encodeURIComponent(query), {
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    success: function(res) {
                                        return async($.map(res, function (entry) {
                                            return entry;
                                        }));
                                    },
                                    complete: function () {
                                        pending.request = null;
                                    }
                                });
                            }, 250);
                        },
                        limit: 2000,
                        templates: {
                            suggestion: function(suggestion) {
                                if (suggestion.suppress_manual_diagnosis && !suggestion.unlocked && !indictedComponentsIds.includes(suggestion.id)) {
                                    return '<p data-suppress="true">' + suggestion.title + '</p>';
                                }
                                return '<p>' + suggestion.title + '</p>';
                            },
                            empty: '<p>' + arc.i18n.get('repairs.not.found') + '</p>'
                        }
                    }
                )
                .on("typeahead:selected", function (event, suggestion, datasetName) {
                    setValue(suggestion);
                    typeahead.typeahead("val", suggestion.title);
                    //close the suggestion list to prevent showing it after selection
                    typeahead.typeahead("close");
                })
                .on("typeahead:open", function (event, suggestion, datasetName) {
                    $("body").css("overflow-x", "unset");
                    $(".tt-open").css("max-height", "200px").css("height", "auto").css("overflow-y", "auto");
                })
                .on("typeahead:close", function (event, suggestion, datasetName) {
                    $("body").css("overflow-x", "hidden");
                });
            $(document).ready(function() {
                initializeTooltipForTypeaheadSelection('p[data-suppress="true"].tt-suggestion', tooltipSelector);
            });
            return typeahead;
        }

        /**
         * The helper function to show tooltip.
         * @param {string} applySelector the selector for elements that will have selector.
         * @param {string} tooltipSelector the selector for tooltip element.
         */
        function initializeTooltipForTypeaheadSelection(applySelector, tooltipSelector) {
            var typeaheadInput = $('.typeahead');
            var tooltip = $('#' + tooltipSelector);

            // Helper to show tooltip on keyboard event
            var tooltipHelper = function (e) {
                var key = e.which || e.keyCode;
                if (key === 13 || key === 9) { // Enter or Tab
                    var activeSuggestion = document.querySelector('.tt-suggestion.tt-cursor');
                    if (activeSuggestion && activeSuggestion.matches(applySelector)) {
                        tooltip.show();
                    }
                } else {
                    tooltip.hide();
                }
            };

            // Tooltip on keyboard events
            document.addEventListener('keydown', tooltipHelper, true);
            document.addEventListener('keypress', tooltipHelper, true);
            document.addEventListener('keyup', tooltipHelper, true);

            // Tooltip on mouse events
            $(document).on({
                mouseenter: function() {tooltip.show(); },
                mouseleave: function() {tooltip.hide(); }
            }, applySelector);

            typeaheadInput.on('typeahead:close', function() {
                tooltip.hide();
            });
            typeaheadInput.on('blur', function() {
                tooltip.hide();
            });
        }

        // expose method
        return {
            initializeTypeahead: function ($input, resourcePath, indictedComponentsIds, tooltipSelector, setValue) {
                return initializeTypeahead($input, resourcePath, indictedComponentsIds, tooltipSelector, setValue);
            }
        };
    })(jQuery, arc);
});